import { useRef } from 'react';
import { Competition } from 'business';
import { useBatchedQuery } from 'bridge';

export default function useInvitedCompetitions(userId?: string) : [Competition[] | undefined, () => void]  {
    const [invitedCompetitions, onLoadMoreInvitedCompetitions] = useBatchedQuery<Competition>({ userId: userId, queryType: 'invitedCompetitions'});
    return [invitedCompetitions, onLoadMoreInvitedCompetitions];
}
